export const mutChangeDefaultActivePath = "mutChangeDefaultActivePath";


// WEBPACK FOOTER //
// ./src/store/mutation-types.js